import { STATUS_OPTION, statusOptions, STEP_OPTION, TIMEFRAME } from "../../constants";

export function lucketActive(lucket, currentDate) {

    if (lucket.date != currentDate) return false
    if (lucket.actionStatus == STATUS_OPTION.White) return false
    if (!lucket.actionStatus) return false
    if (statusOptions.includes(lucket.actionStatus)) {
        return true
    }
    return false
}

export function lucketActiveWeek(lucket, currentDate) {

    if (lucket.date != currentDate) return false
    if (lucket.weekActionStatus == STATUS_OPTION.White) return false
    if (!lucket.weekActionStatus) return false
    if (statusOptions.includes(lucket.weekActionStatus)) {
        return true
    }
    return false
}
export function activeLuckets(luckets, currentDate) {

    if (!luckets || !Array.isArray(luckets)) return []
    let activeLucketsfiltered = luckets.filter((l) => lucketActive(l, currentDate))

    return activeLucketsfiltered
}
export function activeLucketsWeek(luckets, currentDate) {
    if (!luckets || !Array.isArray(luckets)) return []
    let activeLucketsWeekfiltered = luckets.filter((l) => lucketActiveWeek(l, currentDate))

    return activeLucketsWeekfiltered
}
function currentLuckets(luckets, currentDate) {
    // Safety check: ensure luckets is an array
    if (!luckets || !Array.isArray(luckets)) {
        console.log('[Issue 1] currentLuckets - luckets is not an array, returning empty array');
        return [];
    }

    if (luckets && luckets.length > 0) {
    }

    let currentLucketsFiltered = luckets.filter((v) => currentDate == v.date).sort(
        (lucket1, lucket2) => {
            if (lucket1.category < lucket2.category) return -1
            if (lucket1.category > lucket2.category) return 1
            return parseInt(lucket1.order) - parseInt(lucket2.order)
        }
    )

    return currentLucketsFiltered
}

export function filteredBucketList(luckets, step, timeFrame, currentDate) {
    // Safety check: ensure luckets is an array
    if (!luckets || !Array.isArray(luckets)) {
        console.log('[Issue 1] filteredBucketList - luckets is not an array, returning empty array');
        return [];
    }

    switch (step) {

        case STEP_OPTION.Do:
            if (timeFrame == TIMEFRAME.Day) return activeLuckets(luckets, currentDate)
            if (timeFrame == TIMEFRAME.Week) return activeLucketsWeek(luckets, currentDate)
            return luckets;
        case STEP_OPTION.Close:

            return activeLuckets(luckets, currentDate)
        case STEP_OPTION.Plan:
            return currentLuckets(luckets, currentDate)
        default:
            return luckets
    }


}
